import { useId } from "react";

type Props = {
  startColor: string;
  endColor: string;
};

export default function IconRectangle({ startColor, endColor }: Props) {
  const gradientId = useId();

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25 7.58366C3.25 7.00902 3.47827 6.45792 3.8846 6.05159C4.29093 5.64527 4.84203 5.41699 5.41667 5.41699H20.5833C21.158 5.41699 21.7091 5.64527 22.1154 6.05159C22.5217 6.45792 22.75 7.00902 22.75 7.58366V18.417C22.75 18.9916 22.5217 19.5427 22.1154 19.9491C21.7091 20.3554 21.158 20.5837 20.5833 20.5837H5.41667C4.84203 20.5837 4.29093 20.3554 3.8846 19.9491C3.47827 19.5427 3.25 18.9916 3.25 18.417V7.58366Z"
        stroke={`url(#${gradientId})`}
        strokeWidth="1.625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="3.25"
          y1="5.41699"
          x2="17.95"
          y2="24.317"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={startColor} />
          <stop offset="1" stopColor={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
}
